<template>
  <span class="store-my-store-badge" data-testid="store-my-store-badge">
    <svg-icon name="mhj:tick" class="store-my-store-badge__icon" aria-hidden="true" />
    {{ $t('product_details_page.find_store.popup.my_store') }}
  </span>
</template>

<style lang="postcss">
.store-my-store-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-20);
  padding-inline: var(--space-20);
  font-size: var(--text-base);
  font-weight: bold;
  letter-spacing: var(--letter-spacing-default);
  color: var(--text-primary);
  white-space: nowrap;

  .store-my-store-badge__icon {
    width: var(--space-50);
    height: var(--space-50);
  }
}
</style>
